import React from 'react';
import './PasswordStrengthIndicator.css';

const PasswordStrengthIndicator = ({ password, validation }) => {
  if (!password) return null;

  const { strength, hasUpperCase, hasLowerCase, hasNumbers, hasSpecialChar } = validation;

  const getStrengthColor = () => {
    if (strength < 2) return '#ff4444';
    if (strength < 3) return '#ff8800';
    if (strength < 4) return '#ffbb33';
    return '#00C851';
  };

  const getStrengthText = () => {
    if (strength < 2) return 'Too Weak';
    if (strength < 3) return 'Weak';
    if (strength < 4) return 'Moderate';
    return 'Strong';
  };

  return (
    <div className="password-strength">
      <div className="strength-bar">
        <div 
          className="strength-fill"
          style={{ 
            width: `${(strength / 4) * 100}%`,
            backgroundColor: getStrengthColor()
          }}
        />
      </div>
      <div className="strength-text" style={{ color: getStrengthColor() }}>
        {getStrengthText()}
      </div>
      
      <div className="password-requirements">
        <div className={`requirement ${hasLowerCase ? 'met' : 'unmet'}`}>
          <span className="requirement-icon">
            {hasLowerCase ? '✓' : '○'}
          </span>
          Lowercase letter
        </div>
        <div className={`requirement ${hasUpperCase ? 'met' : 'unmet'}`}>
          <span className="requirement-icon">
            {hasUpperCase ? '✓' : '○'}
          </span>
          Uppercase letter
        </div>
        <div className={`requirement ${hasNumbers ? 'met' : 'unmet'}`}>
          <span className="requirement-icon">
            {hasNumbers ? '✓' : '○'}
          </span>
          Number
        </div>
        <div className={`requirement ${hasSpecialChar ? 'met' : 'unmet'}`}>
          <span className="requirement-icon">
            {hasSpecialChar ? '✓' : '○'}
          </span>
          Special character
        </div>
        <div className={`requirement ${password.length >= 8 ? 'met' : 'unmet'}`}>
          <span className="requirement-icon">
            {password.length >= 8 ? '✓' : '○'}
          </span>
          At least 8 characters
        </div>
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator; 